// extracted by mini-css-extract-plugin
export default {"devide":"checkout_devide__S7s0j","useflx":"checkout_useflx__aAWb3","box":"checkout_box__Q8NRc","agree1":"checkout_agree1__fU-X0"};